module.exports = __webpack_public_path__ + "static/media/DOC.8b059e8c.svg";